import { styled } from '@mui/material';

export const TildaIcon = styled('div')(({ theme }) => ({
	lineHeight: 1,
	'&:after': {
		...theme.typography.body2,
		fontSize: 'inherit',
		content: '"≈"',
		lineHeight: 1,
	},
}));
